<div class="layout d-flex">
  <webai-studio-sidebar class="offcanvas offcanvas-start"></webai-studio-sidebar>
  <div class="flex-grow-1">
    <router-outlet></router-outlet>
  </div>
</div>
